import { BaseService } from './base';
import { ReservationStatusType } from '../models/reservationStatusType';

export class ReservationStatusTypeService extends BaseService<ReservationStatusType> {
  override model = ReservationStatusType;
  override modelName = 'reservationStatusType';
  override modelLabel = 'Appointment Status Type';
}
